<template>
  <div id="use">
    <div class="container">
      <div class="parent">
        <div class="center"></div>
        <div class="item" @click="jump(`random`)">
          <svg
            t="1712635284986"
            class="icon"
            viewBox="0 0 1126 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1443"
            width="100"
            height="100"
          >
            <path
              d="M256 409.6m-204.8 0a204.8 204.8 0 1 0 409.6 0 204.8 204.8 0 1 0-409.6 0Z"
              fill="#4B91FF"
              p-id="1444"
            ></path>
            <path
              d="M451.84 200.9088C509.952 80.5888 612.608 45.056 772.4544 82.944l71.2704 16.64c199.3216 46.592 266.9056 155.4944 220.2112 354.6112l-41.7792 178.2784c-40.192 172.6464-128 247.808-280.2688 233.1136a486.0416 486.0416 0 0 1-74.9568-12.4416l-71.68-17.0496c-198.656-47.2064-266.24-155.904-219.648-354.6112l41.8304-178.7904c9.5232-40.3456 20.736-74.0352 34.4064-101.7856z m303.0528-43.2128c-127.7952-30.208-193.1776-7.68-234.0352 76.8512-10.9568 22.2208-20.3776 50.5856-28.672 85.6576l-41.7792 178.7904c-36.9152 157.44 5.0176 224.9216 162.6624 262.3488l71.7824 17.1008c22.8864 5.5296 43.9296 9.0624 63.7952 10.6496 111.5648 10.752 166.7072-36.4544 198.7072-174.08l41.8304-178.3296c36.9664-157.7984-4.9152-225.3824-162.9184-262.3488l-71.3728-16.64z"
              fill="#292D32"
              p-id="1445"
            ></path>
            <path
              d="M479.232 179.8656a38.4 38.4 0 0 1 41.6256 54.6816c-10.9568 22.2208-20.3776 50.5856-28.672 85.6576l-41.7792 178.7904c-36.9152 157.44 5.0176 224.9216 162.6624 262.3488l71.7824 17.1008a410.624 410.624 0 0 0 63.1808 10.5984c36.1472 2.8672 48.4864 49.664 18.432 70.0416-29.1328 19.7632-65.1264 36.1984-109.7728 50.7904l-67.584 22.2208c-189.5936 61.1328-300.3392 4.4544-361.984-185.088L172.544 578.4064C111.36 388.608 167.936 277.504 357.0688 216.5248l67.7888-22.3232c21.0944-6.656 38.1952-11.264 54.4256-14.336zM424.5504 275.1488l-43.6736 14.3872c-148.8896 48.0256-183.3984 115.8144-135.2192 265.216l54.5792 168.5504c48.5376 149.248 116.1216 183.808 265.1136 135.7824l53.1968-17.5104-23.1936-5.4784c-194.3552-46.1312-263.168-151.0912-222.6176-341.504l2.9184-13.1072 41.8304-178.7904c1.3824-5.7856 2.7648-11.4176 4.1984-16.896l2.8672-10.6496zM604.4672 354.5088a38.4 38.4 0 0 1 46.6944-27.8016l206.8992 52.48a38.4 38.4 0 1 1-18.8416 74.4448l-206.9504-52.48a38.4 38.4 0 0 1-27.8016-46.6432z"
              fill="#292D32"
              p-id="1446"
            ></path>
            <path
              d="M562.688 519.5776a38.4 38.4 0 0 1 46.6944-27.6992l123.7504 31.5392a38.4 38.4 0 1 1-18.9952 74.4448l-123.7504-31.5904a38.4 38.4 0 0 1-27.6992-46.6944z"
              fill="#292D32"
              p-id="1447"
            ></path>
          </svg>
          <div class="title">{{ $t("uk.random") }}</div>
        </div>
        <div class="item" @click="jump(`guide`)">
          <svg
            t="1712639015495"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1614"
            width="100"
            height="100"
          >
            <path
              d="M358.4 358.4m-153.6 0a153.6 153.6 0 1 0 307.2 0 153.6 153.6 0 1 0-307.2 0Z"
              fill="#4B91FF"
              p-id="1615"
            ></path>
            <path
              d="M563.2 819.2m-153.6 0a153.6 153.6 0 1 0 307.2 0 153.6 153.6 0 1 0-307.2 0Z"
              fill="#4B91FF"
              p-id="1616"
            ></path>
            <path
              d="M938.6496 238.9504a38.4 38.4 0 1 1 0 76.8h-256a38.4 38.4 0 0 1 0-76.8h256zM256 238.9504a38.4 38.4 0 1 1 0 76.8H85.3504a38.4 38.4 0 1 1 0-76.8H256z"
              fill="#292D32"
              p-id="1617"
            ></path>
            <path
              d="M426.6496 89.6a187.7504 187.7504 0 1 1 0 375.4496 187.7504 187.7504 0 0 1 0-375.4496z m0 76.8a110.9504 110.9504 0 1 0 0 221.8496 110.9504 110.9504 0 0 0 0-221.8496zM938.6496 708.2496a38.4 38.4 0 0 1 0 76.8H768a38.4 38.4 0 1 1 0-76.8h170.6496zM341.3504 708.2496a38.4 38.4 0 0 1 0 76.8h-256a38.4 38.4 0 1 1 0-76.8h256z"
              fill="#292D32"
              p-id="1618"
            ></path>
            <path
              d="M597.3504 558.9504a187.7504 187.7504 0 1 1 0 375.4496 187.7504 187.7504 0 0 1 0-375.4496z m0 76.8a110.9504 110.9504 0 1 0 0 221.8496 110.9504 110.9504 0 0 0 0-221.8496z"
              fill="#292D32"
              p-id="1619"
            ></path>
          </svg>
          <div class="title">{{ $t("uk.guide") }}</div>
        </div>
        <div class="item" @click="jump(`download`)">
          <svg
            t="1712639037231"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1786"
            width="100"
            height="100"
          >
            <path
              d="M512 469.333333l-100.309333 52.736 19.157333-111.701333-81.152-79.104 112.128-16.298667L512 213.333333l50.176 101.632 112.128 16.298667-81.152 79.104 19.2 111.701333z"
              fill="#4B90FF"
              p-id="1787"
            ></path>
            <path
              d="M512 53.333333A330.453333 330.453333 0 0 1 842.666667 384a329.386667 329.386667 0 0 1-55.381334 183.893333c-52.010667 77.013333-133.546667 129.152-224.938666 142.464a289.322667 289.322667 0 0 1-50.346667 4.309334 285.44 285.44 0 0 1-49.408-4.181334 330.112 330.112 0 0 1-225.962667-142.762666A329.258667 329.258667 0 0 1 181.333333 384 330.453333 330.453333 0 0 1 512 53.333333z m0 64A266.453333 266.453333 0 0 0 245.333333 384c0 53.973333 15.573333 104.746667 44.458667 148.053333a266.581333 266.581333 0 0 0 182.954667 115.242667 229.418667 229.418667 0 0 0 79.445333-0.170667 265.898667 265.898667 0 0 0 181.930667-114.901333A265.258667 265.258667 0 0 0 778.666667 384 266.453333 266.453333 0 0 0 512 117.333333z"
              fill="#292D32"
              p-id="1788"
            ></path>
            <path
              d="M734.208 532.48a32 32 0 0 1 49.152-4.693333l166.186667 166.186666c41.557333 40.789333 21.248 111.786667-35.498667 125.226667l-70.229333 16.597333a10.154667 10.154667 0 0 0-7.978667 7.893334l-14.933333 62.72c-14.208 59.733333-90.368 77.653333-129.536 31.061333L512 731.392l-178.986667 206.08c-38.144 45.397333-110.506667 30.250667-128.170666-24.618667l-1.706667-6.016-14.890667-62.592a10.666667 10.666667 0 0 0-7.850666-7.978666l-70.4-16.64c-56.746667-13.44-76.928-84.224-35.712-125.44l166.4-166.4a32 32 0 0 1 49.152 4.693333 266.581333 266.581333 0 0 0 182.954666 115.242667c12.672 2.261333 25.728 3.370667 39.253334 3.370666l-4.48-0.128 4.48-0.298666 4.394666 0.298666 9.002667-0.256a226.56 226.56 0 0 0 13.312-1.152l13.482667-1.962666a266.026667 266.026667 0 0 0 182.016-115.114667zM259.968 598.869333L119.466667 739.413333a10.794667 10.794667 0 0 0 5.248 17.92l69.973333 16.554667c27.392 6.058667 49.024 27.733333 55.765333 55.381333l14.933334 62.72c2.005333 8.533333 12.885333 11.093333 18.944 3.925334l162.986666-187.648-9.642666-1.962667a329.301333 329.301333 0 0 1-169.770667-98.56l-7.936-8.874667z m503.978667 0l-7.850667 8.917334a328.661333 328.661333 0 0 1-169.088 98.389333l-10.24 2.090667 163.242667 187.605333c5.077333 6.058667 14.250667 4.693333 17.621333-1.706667l0.981333-2.56 14.805334-62.08a73.898667 73.898667 0 0 1 55.466666-55.978666l70.4-16.64c8.021333-1.877333 10.88-11.946667 5.248-17.493334l-140.586666-140.544z"
              fill="#292D32"
              p-id="1789"
            ></path>
            <path
              d="M459.392 241.92c23.637333-52.181333 80.426667-52.181333 105.984-1.066667l24.192 48.298667 43.605333 7.381333c52.821333 8.533333 70.4 57.984 36.565334 96.725334l-4.138667 4.394666-33.621333 33.621334 9.728 41.813333c14.08 60.074667-30.421333 95.104-82.901334 67.84l-5.461333-3.072-40.533333-23.936-40.576 24.021333c-53.077333 30.933333-99.584-0.554667-89.514667-58.666666L384 473.173333l9.728-41.898666-33.621333-33.621334c-37.802667-37.76-23.68-87.594667 26.325333-99.84l5.930667-1.28 43.306666-7.296 23.722667-47.317333z m53.248 36.565333l-20.650667 41.301334c-8.021333 16-25.642667 29.226667-43.392 32.213333l-37.418666 6.229333 29.568 29.610667c12.16 12.16 18.432 31.573333 16.768 49.365333l-0.981334 6.528-7.850666 33.792 33.408-19.712a62.165333 62.165333 0 0 1 55.637333-3.157333l5.461333 2.901333 33.834667 19.968-7.765333-33.28a62.421333 62.421333 0 0 1 11.733333-51.968l3.968-4.437333 29.568-29.610667-37.12-6.186666a63.146667 63.146667 0 0 1-41.045333-26.965334l-3.072-5.290666-20.650667-41.301334z"
              fill="#292D32"
              p-id="1790"
            ></path>
          </svg>
          <div class="title">{{ $t("uk.download") }}</div>
        </div>
        <div class="item" @click="jump(`self`)">
          <svg
            t="1712635165423"
            class="icon"
            viewBox="0 0 1152 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1274"
            width="100"
            height="100"
          >
            <path
              d="M882.474667 314.325333l176.896 353.749334A128 128 0 0 1 944.896 853.333333h-353.792a128 128 0 0 1-114.474667-185.258666l176.896-353.749334a128 128 0 0 1 228.949334 0z"
              fill="#4B91FF"
              p-id="1275"
            ></path>
            <path
              d="M512 352a32 32 0 0 1 32 32v213.333333a32 32 0 1 1-64 0V384a32 32 0 0 1 32-32z"
              fill="#292D32"
              p-id="1276"
            ></path>
            <path
              d="M345.770667 197.802667c88.149333-158.933333 244.309333-158.933333 332.458666 0l125.44 225.706666 133.12 239.786667c83.498667 150.613333 5.802667 282.624-166.229333 282.624H512a32.298667 32.298667 0 0 1-4.352-0.298667l-0.64-0.128H253.44c-169.173333 0-246.869333-127.061333-170.666667-274.261333l4.437334-8.362667 133.12-239.786666 125.44-225.28z m276.48 31.061333c-63.744-114.986667-156.757333-114.986667-220.544 0l-125.44 225.28-133.12 239.786667c-59.904 108.074667-13.226667 187.562667 110.293333 187.562666H512c1.493333 0 2.901333 0.085333 4.352 0.298667l0.64 0.085333 253.568 0.042667c120.405333 0 167.893333-75.946667 114.261333-180.053333l-4.010666-7.509334-133.12-239.786666-125.44-225.706667z"
              fill="#292D32"
              p-id="1277"
            ></path>
            <path
              d="M516.053333 682.666667a42.666667 42.666667 0 1 1 0 85.333333h-4.266666a42.666667 42.666667 0 0 1 0-85.333333h4.266666z"
              fill="#292D32"
              p-id="1278"
            ></path>
          </svg>

          <div class="title">{{ $t("uk.common") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
let router = useRouter();
localStorage.setItem("router", "use");

function jump(params) {
  if (params == "download") {
    router.push(`/download2`);
  } else {
    router.push(`/${params}`);
  }
}
</script>

<style scoped>
#use {
  padding: 150px 0px;
  background-color: #f7f9fa;
}
.zeropadding {
  padding: 0px;
}
.parent {
  width: 100%;
  position: relative;
  padding: 50px 2%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.item {
  width: 23%;
  height: 400px;
  padding: 100px 0px;
  background-color: white;
  box-shadow: 0 6px 15px rgba(36, 37, 38, 0.08);
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.25s ease, transform 0.25s ease;
  cursor: pointer;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.item:hover {
  box-shadow: 5px 12px 20px rgba(36, 37, 38, 0.13);
  background-color: #dddddd;
}
.wait {
  background-color: #dddddd;
}
.img {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  background-color: #705ecf;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  margin-bottom: 30px;
}
.icon {
  margin-bottom: 30px;
}
.title {
  text-align: center;
  font-size: 24px;
  color: black;
}
.center {
  width: 100%;
  height: 175px;
  background-color: white;
  position: absolute;
  left: 50%;
  top: 0%;
  margin-top: 30px;
  transform: translate(-50%, 0%);
  box-shadow: 0 6px 15px rgba(36, 37, 38, 0.08);
  z-index: 1;
  background-color: #6699cc;
}
</style>
